import React from 'react';

const PartnersSlider = () => {
  const partners = [
    { name: 'Beans', logo: '/images/beans_logo.svg', url: 'https://x.com/BeansApp' },
    { name: 'Decaf', logo: '/images/decaf_logo.svg', url: 'https://x.com/Decaf_so' },
    { name: 'Stellar', logo: '/images/stellar_logo.svg', url: 'https://x.com/StellarOrg' },
    { name: 'Hot Wallet', logo: '/images/hot_logo.svg', url: 'https://x.com/hotdao_' },
    { name: 'Sodax', logo: '/images/sodax_logo.svg', url: 'https://x.com/gosodax' },
  ];

  return (
    <div className="overflow-hidden py-4">
      <div 
        className="flex items-center animate-scroll-infinite"
        style={{ 
          gap: '15rem',
          width: 'max-content'
        }}
      >
        {/* Double the partners for seamless infinite loop */}
        {[...partners, ...partners, partners[0]].map((partner, index) => (
          <div
            key={index}
            className="flex-shrink-0 p-2"
            style={{ minWidth: '200px' }}
          >

              <img 
                src={partner.logo} 
                alt={`${partner.name} logo`}
                className="h-16 w-auto transition-all duration-300 filter brightness-0 invert mx-auto"
                style={{ 
                  maxWidth: '200px',
                  objectFit: 'contain'
                }}
              />

          </div>
        ))}
      </div>
      
      <style jsx>{`
        @keyframes scroll-infinite {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-47.8%);
          }
        }
        
        .animate-scroll-infinite {
          animation: scroll-infinite 20s linear infinite;
        }
        
        .animate-scroll-infinite:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default PartnersSlider;